<template>
  <div class="carousel-1 slider" id="carousel-1">
    <!-- home-card -->
    <div
      v-for="(myclass, myindex) in getClassList"
      class=""
      :class="[
        cs.selectClassId === myclass.courseid && route.name === 'DailyGoal'
          ? 'card'
          : 'card',
        hkClassBg(myindex),
      ]"
      @click="selectClass(myclass.course_name, myclass.courseid, myclass)"
      :id="myclass.courseid"
    >
      <div
        class="card-body d-flex flex-column justify-content-between"
        :class="userCustomization.userGroup === 'B2C' ? '' : 'hk-height'"
      >
        <div class="d-flex flex-column justify-content-between">
          <div class="text-white font-weight-bold m-text">
            {{ myclass.course_name }}
          </div>
          <p class="myclass-teacher text-white mb-0">
            {{ getTeacher(myclass.teachername) }}
          </p>
          <div class="img-minus-padding pr-1">
            <!-- <h4 class="text-white">{{ myclass.onlineStu }}</h4> -->
            <img
              v-for="student in myclass.onlineStu"
              :key="student.id"
              :src="$getAvatar(student.avatar, false, student.title_lvl)"
              class="w-40 rounded-circle bg-avatar"
            />
          </div>
        </div>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row align-self-end"></div>
          <div v-if="route.name !== 'DailyGoal'">
            <!-- icon-box icon-box-solid icon-radius -->
            <!-- <button
                @click="$goPage(`/msu/class/class-page/${myclass.courseid}`)"
                class="btn btn-sm btn-home m-text msu-semibold"
                type="button"
              >
                {{ $t("go-0") }}
                <i class="zmdi zmdi-arrow-right zmdi-hc-fw btn-icon-home"></i>
              </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END 我的班級 -->
</template>
<script setup>
import { useClassStore } from "@/store/modules/class.js";
import { computed } from "@vue/runtime-core";
import { useI18n } from "vue-i18n";
import { useGlobalStore } from "@/store/modules/global";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";
const { locale, t } = useI18n({
  inheritLocale: true,
});

const cs = useClassStore();
const userCustomization = useUserCustomizationStore();

const route = useRoute();

const selectClass = (cname, cid, myclass) => {
  console.log("select classs = ", cname, cid);
  if (route.name === "DailyGoal") {
    cs.$patch((state) => {
      state.selectClass = cname;
      state.selectClassId = cid;
    });
  } else {
    $goPage(`/msu/class/class-page/${myclass.courseid}`);
  }
};
const $getAvatar = inject("$getAvatar");
const getTeacher = (item) => {
  if (item.includes(",")) {
    return t("multiple-teachers");
  } else {
    return item;
  }
};

const $goPage = inject("$goPage");
const getClassList = computed(() => {
  return cs.classList;
  // if (props.classList.length !== 0) {
  //   return props.classList;
  // } else {
  //   return cs.classList;
  // }
});
const hkClassBg = (index) => {
  // 只有非 B2C 用戶才適用 hkClassBg 樣式
  if (userCustomization.userGroup !== "B2C") {
    return "hk-class-bg4";
  }
  return "hk-class-bg4-B2C"; // B2C 用戶不返回背景樣式
};

const classIndex = ref(0);
onMounted(() => {
  global.$patch((state) => {
    // state.isLoading = true;
  });
  $(".carousel-1")
    .not(".slick-initialized")
    .slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false,
          },
        },
      ],
    });
  $(".slick-next").click(function () {});
  $(".slick-prev").click(function () {});
  $(".carousel-1").on("afterChange", function (event, slick, currentSlide) {
    // 滑動時自動切換內容
    if (route.name === "DailyGoal") {
      let nowClass = JSON.parse(
        JSON.stringify(getClassList.value[currentSlide])
      );
      console.log(nowClass);
      cs.$patch((state) => {
        state.selectClass = nowClass.course_name;
        state.selectClassId = nowClass.courseid;
      });
    }
  });
  if (
    route.name === "DailyGoal" &&
    route.params.class !== "*" &&
    cs.classList.length !== 0
  ) {
    let myindex = 0;
    let myclass = cs.classList.filter((c, index) => {
      console.log(c);
      if (c.courseid === route.params.class) {
        myindex = index;
      }
      return c.courseid === route.params.class;
    });
    $(".carousel-1").slick("slickGoTo", myindex);
    let fromClass = JSON.parse(JSON.stringify(myclass));
    selectClass(fromClass[0].course_name, fromClass[0].courseid);
  }
});

// onUpdated(() => {
//   $(".carousel-1")
//     .not(".slick-initialized")
//     .slick({
//       dots: true,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             infinite: true,
//             dots: true,
//             arrows: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             infinite: true,
//             dots: true,
//             arrows: false,
//           },
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             infinite: true,
//             dots: true,
//             arrows: false,
//           },
//         },
//       ],
//     });
//   classCardLoading.value = true;
// });
const classCardLoading = ref(false);
const global = useGlobalStore();
const loadCarousel = () => {
  if (getClassList.value.length > 0) {
    $(".carousel-1")
      .not(".slick-initialized")
      .slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              arrows: false,
            },
          },
        ],
      });
    setTimeout(() => {
      global.$patch((state) => {
        state.isLoading = false;
      });
    }, 500);
  }
};

watch(
  () => getClassList.value,
  (val, oldVal) => {
    if (val.length !== 0) {
      loadCarousel();
    }
  }
);
</script>
<style lang="scss" scoped>
.bg-avatar {
  background-color: #4e4f97;
}

.hk-class-bg4 {
  background-image: url("../assets/img/background/My_class_icon-04.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 68% 80%;
  background-size: 40%;
  min-height: 240px;
  background-color: #4eb1d1;
}
.hk-class-bg4-B2C {
  background-image: url("../assets/img/background/My_class_icon-04.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 68% 80%;
  background-size: 40%;
  background-color: #4eb1d1;
}
.hk-class-bg4:hover {
  background-color: #71d3ec;
}
@media (max-width: 575.98px) {
  .hk-class-bg4 {
    background-size: 42%;
    background-position: 80% 20%;
  }
}
.hk-height {
  min-height: 240px;
  // background-color: #4eb1d1;
}
.hk-GO-w {
  width: 100px;
  height: 40px;
}

.myclass .card .myclass-online {
  font-size: 1rem !important;
}
.home-card {
  border-radius: 1rem;
  box-shadow: 0 10px 40px #126ad312, 0 2px 9px #126ad30f;
  border: none;
  margin-bottom: 1.875rem;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
